export const clientId: string =
  process.env.GOOGLE_CLIENT_ID ||
  "534451231648-d2a526h66llkn1e781gv6fgjvofsph2c.apps.googleusercontent.com";
